module.exports = __webpack_public_path__ + "img/shop-process1.979afd83.png";